<template>
  <section class="task-overview-card">
    <div class="overview-left">
      <div class="overview-header-badge">
        <span class="overview-icon-box">
          <TrendingUp :size="14" />
        </span>
        <span class="overview-title-text">任务效能概览</span>
        <span class="overview-period-tag">本月实时</span>
      </div>

      <div class="overview-hero-metric">
        <span class="metric-label">当月完成设计</span>
        <div class="metric-value-row">
          <strong class="metric-num">{{ stats.completedCurrentMonth || stats.completed || 0 }}</strong>
          <span class="metric-unit">单</span>
        </div>
      </div>

      <div class="overview-status-grid">
        <div class="status-mini-pill tone-completed">
          <span class="status-dot"></span>
          <span class="status-name">已完成</span>
          <strong class="status-val">{{ stats.completed || 0 }}</strong>
        </div>
        <div class="status-mini-pill tone-designing">
          <span class="status-dot"></span>
          <span class="status-name">设计中</span>
          <strong class="status-val">{{ stats.designing || 0 }}</strong>
        </div>
        <div class="status-mini-pill tone-pending">
          <span class="status-dot"></span>
          <span class="status-name">待设计</span>
          <strong class="status-val">{{ stats.pending || 0 }}</strong>
        </div>
        <div class="status-mini-pill tone-returned">
          <span class="status-dot"></span>
          <span class="status-name">工厂退回</span>
          <strong class="status-val">{{ stats.returned || 0 }}</strong>
        </div>
        <div class="status-mini-pill tone-sales">
          <span class="status-dot"></span>
          <span class="status-name">退回销售</span>
          <strong class="status-val">{{ stats.returnedSales || 0 }}</strong>
        </div>
        <div class="status-mini-pill tone-refunded">
          <span class="status-dot"></span>
          <span class="status-name">已退款</span>
          <strong class="status-val">{{ stats.refunded || 0 }}</strong>
        </div>
      </div>
    </div>

    <div class="overview-right">
      <div class="overview-chart-wrapper">
        <div class="overview-donut-ring" :style="donutStyle">
          <div class="donut-inner-card">
            <span class="donut-sub">总任务数</span>
            <strong class="donut-total">{{ stats.total || 0 }}</strong>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { TrendingUp } from '@lucide/vue';

const props = defineProps({ stats: { type: Object, required: true } });

const donutStyle = computed(() => {
  const values = [
    props.stats.completed,
    props.stats.designing,
    props.stats.pending,
    props.stats.returned,
    props.stats.returnedSales,
    props.stats.refunded,
  ].map(Number);
  const total = values.reduce((sum, value) => sum + (value || 0), 0);
  if (!total) return { background: 'conic-gradient(#e2e8f0 0 100%)' };
  
  const colors = ['#7c3aed', '#3b82f6', '#f59e0b', '#ef4444', '#ec4899', '#cbd5e1'];
  let cursor = 0;
  const stops = values.map((value, index) => {
    const start = cursor;
    cursor += (value / total) * 100;
    return `${colors[index]} ${start}% ${cursor}%`;
  });
  return { background: `conic-gradient(${stops.join(', ')})` };
});
</script>
